import { ISearchSuggest } from "@/redux/search/suggest/types";

export const getSearchQuery = (s: ISearchSuggest) => s.searchSuggest?.query;

export const getSearchResults = (s: ISearchSuggest) => s.searchSuggest?.results;

export const getActiveSearchIndex = (s: ISearchSuggest) =>
  s.searchSuggest?.activeIndex;
